export enum NewsListAction {
  NEWS_LIST_REQUEST = 'NEWS_LIST_REQUEST',
  NEWS_LIST_REQUEST_SUCCESS = 'NEWS_LIST_REQUEST_SUCCESS',
  NEWS_LIST_REQUEST_FAIL = 'NEWS_LIST_REQUEST_FAIL',
}

export const NEWS_DETAILS_REQUEST = 'NEWS_DETAILS_REQUEST';
export const NEWS_DETAILS_REQUEST_SUCCESS = 'NEWS_DETAILS_REQUEST_SUCCESS';
export const NEWS_DETAILS_REQUEST_FAIL = 'NEWS_DETAILS_REQUEST_FAIL';

export enum NewsCategoryAction {
  NEWS_CATEGORY_REQUEST = 'NEWS_CATEGORY_REQUEST',
  NEWS_CATEGORY_REQUEST_SUCCESS = 'NEWS_CATEGORY_REQUEST_SUCCESS',
  NEWS_CATEGORY_REQUEST_FAIL = 'NEWS_CATEGORY_REQUEST_FAIL',
}

export const NEWS_CATEGORY_REQUEST = 'NEWS_CATEGORY_REQUEST';
export const NEWS_CATEGORY_REQUEST_SUCCESS = 'NEWS_CATEGORY_REQUEST_SUCCESS';
export const NEWS_CATEGORY_REQUEST_FAIL = 'NEWS_CATEGORY_REQUEST_FAIL';
